import { connect } from 'react-redux'
import ModelUploader from './ModelUploader'
import { withRouter } from 'react-router-dom'
import { fetchAllUsers } from '../../../redux/actions/user_actions'
import { saveFileList, approveModel, removeFileFromList, fetchFileListData, removeModel } from '../../../redux/actions/model_actions'

const mSTP = state => ({
  users: state.users,
  currentUserId: state.session.user.id,
  currentUser: state.session.user.username,
  currentUserRole: state.session.user.role,
  fileList: state.model_uploader
});

const mDTP = dispatch => ({
  approveModel: (payload) => dispatch(approveModel(payload)),
  fetchAllUsers: (cancelToken) => dispatch(fetchAllUsers(cancelToken)),
  fetchFileListData: (cancelToken) => dispatch(fetchFileListData(cancelToken)),
  updateFileList: (file, index) => dispatch(saveFileList(file, index)),
  removeFileFromList: (index) => dispatch(removeFileFromList(index)),
  removeModel: (id) => dispatch(removeModel(id))
});

export default withRouter(connect(mSTP, mDTP)(ModelUploader));